module.exports = __webpack_public_path__ + "img/blog-57.befde77f.jpg";